module.exports = __webpack_public_path__ + "img/9d1916d.png";